import React from 'react';
import { RotateCcw, Clock, ShieldCheck, BookOpen, AlertTriangle, Scale, Gavel } from 'lucide-react';

const TerminosPage = () => {
  const seccionesTerminos = [
    {
      id: 1,
      titulo: 'Objeto del servicio',
      icono: <BookOpen size={20} className="text-[#CE010B] dark:text-white" />,
      contenido: [
        'Más Envíos ofrece el servicio de recolección, traslado y entrega de paquetes dentro de las rutas establecidas Pachuca – Toluca – Ciudad de México.',
      ],
    },
    {
      id: 2,
      titulo: 'Declaración del cliente',
      icono: <ShieldCheck size={20} className="text-[#CE010B] dark:text-white" />,
      contenido: [
        'El cliente manifiesta que:',
        {
          lista: [
            'El contenido del envío es lícito.',
            'No incluye artículos prohibidos.',
            'El paquete se encuentra debidamente embalado.',
            'Asume la responsabilidad total por la exactitud de los datos de envío.',
          ],
        },
      ],
    },
    {
      id: 3,
      titulo: 'Objetos prohibidos',
      icono: <AlertTriangle size={20} className="text-[#CE010B] dark:text-white" />,
      contenido: [
        'No se transportan bajo ninguna circunstancia:',
        {
          lista: [
            'Armas o municiones.',
            'Sustancias ilegales o drogas.',
            'Material inflamable o explosivo.',
            'Animales vivos o restos humanos.',
            'Dinero en efectivo o valores negociables.',
          ],
        },
      ],
    },
    {
      id: 4,
      titulo: 'Límites de responsabilidad',
      icono: <Gavel size={20} className="text-[#CE010B] dark:text-white" />,
      contenido: [
        {
          lista: [
            'La responsabilidad de Más Envíos se limita al valor declarado del envío.',
            'En caso de pérdida comprobable, la indemnización no excederá el valor declarado.',
            'No nos hacemos responsables por daños ocasionados por embalaje inadecuado.',
            'No aplica la responsabilidad por causas de fuerza mayor (clima, bloqueos, accidentes).',
          ],
        },
      ],
    },
    {
      id: 5,
      titulo: 'Tiempos de entrega',
      icono: <Clock size={20} className="text-[#CE010B] dark:text-white" />,
      contenido: [
        {
          lista: [
            'Los tiempos son estimados y pueden variar por condiciones externas o causas imprevistas.',
            'El horario de corte para servicios Express es a las 13:00 hrs.',
          ],
        },
      ],
    },
    {
      id: 6,
      titulo: 'Cancelaciones y reembolsos',
      icono: <RotateCcw size={20} className="text-[#CE010B] dark:text-white" />,
      contenido: [
        {
          lista: [
            'No hay reembolsos una vez iniciado el traslado del paquete.',
            'Las cancelaciones deben solicitarse antes de la recolección en sucursal.',
          ],
        },
      ],
    },
  ];

  return (
    <div className="min-h-screen w-full relative bg-cover bg-center flex flex-col items-center transition-all duration-500" 
         style={{ backgroundImage: "url('/fondo-camiones-repartidores.jpg')" }}>

      <header className="z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-6 md:py-10 flex flex-col items-center text-center">
        <div className="flex items-center gap-3 md:gap-4 mb-3 group">
          <ShieldCheck 
            size={36} 
            className="text-white group-hover:text-[#CE010B] dark:group-hover:text-white group-hover:scale-110 transition-all duration-300 md:w-[42px] md:h-[42px]" 
          />
          <h1 className="text-3xl md:text-5xl font-black text-white tracking-tight" 
              style={{ fontFamily: "'Secular One', sans-serif" }}>
            Términos y condiciones
          </h1>
        </div>
        <p className="text-xl md:text-xl text-gray-200 dark:text-white/80 font-medium max-w-2xl mb-2 px-2">
          Se establecen las reglas y pautas para el uso de nuestros servicios de logística.
        </p>
        <div className="h-[1px] bg-white/20 w-full max-w-5xl my-4"></div>
      </header>
      
      <main className="z-10 w-full max-w-5xl mx-auto px-4 md:px-6 pb-20 mt-2 md:mt-4">
        <div className="rounded-2xl md:rounded-[3rem] p-6 md:p-12 shadow-2xl flex flex-col gap-6 md:gap-10 transition-all duration-500 border-2 dark:border-[3px]
          bg-gradient-to-b from-[#F1F1F1] to-[#C1C1C1] border-black/20
          dark:from-[#590000] dark:to-[#780000] dark:border-white"
        >
          {seccionesTerminos.map((seccion) => (
            <section key={seccion.id} className="flex flex-col gap-4 md:gap-5 items-center">
              
              <div className="flex items-center gap-3 border-b pb-2 border-[#CE010B]/50 dark:border-white/30">
                {seccion.icono}
                <h3 className="text-xl md:text-xl font-bold uppercase tracking-tighter text-[#CE010B] dark:text-white" 
                    style={{ fontFamily: "'Secular One', sans-serif" }}>
                  {seccion.id}. {seccion.titulo}
                </h3>
              </div>
              
              <div className="w-full p-5 md:p-6 shadow-xl rounded-2xl transition-all duration-500 border-2 dark:border-[3px]
                bg-gradient-to-b from-[#F1F1F1] to-[#C1C1C1] border-black/10
                dark:from-[#590000] dark:to-[#780000] dark:border-white"
              >
                {seccion.contenido.map((item, index) => {
                  if (typeof item === 'object' && item.lista) {
                    return (
                      <ul key={index} className="list-disc list-outside text-xl md:text-sm font-medium mt-3 pl-6 pr-2 md:px-10 text-left text-gray-800 dark:text-white">
                        {item.lista.map((li, liIndex) => (
                          <li key={liIndex} className="mb-2 leading-relaxed">{li}</li>
                        ))}
                      </ul>
                    );
                  }
                  return (
                    <p key={index} className="text-xl md:text-sm font-bold leading-relaxed px-2 md:px-5 text-gray-800 dark:text-white">
                      {item}
                    </p>
                  );
                })}
              </div>
            </section>
          ))}
          
          <div className="w-full h-[1px] bg-black/10 dark:bg-white/20 my-4"></div>
          <p className="text-sm md:text-xs text-center font-medium text-gray-500 dark:text-white/60">
            Última actualización: Octubre de 2026.
          </p>
        </div>
      </main>
    </div>
  );
};

export default TerminosPage;